export default __webpack_public_path__ + "static/media/brand-7.a70218e3.png";